/* global SentryDsn, SentryRelease, SentryEnvironment */
import { createInertiaApp, Link, Head } from '@inertiajs/vue3';
import { createApp, h } from 'vue';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing'; // @todo: possibly add initialPage: JSON.parse(app.dataset.page),

export default createInertiaApp({
  resolve: function resolve(name) {
    return import("./Pages/".concat(name)).then(function (module) {
      return module["default"];
    });
  },
  setup: function setup(_ref) {
    var el = _ref.el,
        App = _ref.App,
        props = _ref.props,
        plugin = _ref.plugin;
    var app = createApp({
      render: function render() {
        return h(App, props);
      }
    }).use(plugin).component('InertiaLink', Link).component('InertiaHead', Head);
    Sentry.init({
      app: app,
      dsn: SentryDsn,
      release: SentryRelease,
      environment: SentryEnvironment,
      integrations: [new Integrations.BrowserTracing()],
      tracesSampleRate: 0.25,
      tracingOptions: {
        trackComponents: true
      }
    });
    app.mount(el);
  },
  progress: {
    // The delay after which the progress bar will
    // appear during navigation, in milliseconds.
    delay: 250,
    // The color of the progress bar.
    color: '#29d',
    // Whether to include the default NProgress styles.
    includeCSS: true,
    // Whether the NProgress spinner will be shown.
    showSpinner: false
  }
});